export default "__VITE_ASSET__98752af5__"